module.exports = __webpack_public_path__ + "static/media/full-icon.9310b357.svg";